import { createSlice } from '@reduxjs/toolkit';
import { sidebarShowAction } from '../actions/sidebar';

// initial state
const initialState = {
  loading: false,
  sidebarShow: true,
  error: false,
  success: false,
};

// side slice
const sidebarSlice = createSlice({
  name: 'sidebar',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(sidebarShowAction.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(sidebarShowAction.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.sidebarShow = action.payload;
        state.error = false;
      })
      .addCase(sidebarShowAction.rejected, (state, action) => {
        state.loading = false;
        state.error = true;
        state.success = false;
      });
  },
});

export default sidebarSlice.reducer;
